import { useContext } from "react";
import { LocaleContext } from "../../utils/context";

export const useLocale = () => {
    const { locale } = useContext(LocaleContext)
    return locale
}